<div class="field-location field--icon">
  <i class="icon icon-address"></i>
  <input class="form-control" type="text" name="location" [ngClass]="{'is-error': errors[0]}"/>
  <span class="field__btn" (click)="findMe($event)" *ngIf="value === null"><i class="icon-marker"></i><span class="find-me"> Znajdź mnie</span></span>
  <span class="field__btn" (click)="clear()" *ngIf="value !== null"><i class="icon-x"></i></span>
</div>
